<template src="./Header.html"></template>
<style src="./Header.scss" lang="scss"></style>

<script>
	import Searchbar from '@/components/Searchbar/Searchbar';
	import Button from '@/components/Button/Button';
	import Navigation from '@/components/Navigation/Navigation';
	import Burger from '@/components/Burger/Burger';

	export default {
		name: 'HpHeader',
		data() {
			return {
				loginButtonImportance: 'accent',
				brand: ''
			};
		},
		// methods: {
		// 	setEmailLogin(event) {
		// 		event.preventDefault();
		// 		const bentoComponent = this.$refs.bento;
		// 		const firstEntryOfBento = bentoComponent.$el.querySelector('div > div:first-of-type > div:first-child > a > figure');
		// 		bentoComponent.toggleLogin(
		// 			{
		// 				target: firstEntryOfBento
		// 			},
		// 			'row1',
		// 			0,
		// 			true
		// 		);
		// 	}
		// },
		created() {
			this.brand = process.env.VUE_APP_BRAND;
			if (this.brand === 'webde') {
				this.loginButtonImportance = 'primary';
			}
		},
		components: {
			'hp-searchbar': Searchbar,
			'hp-button': Button,
			'hp-navigation': Navigation,
			'hp-burger': Burger
		}
	};
</script>
